__turbopack_context__.v({
  "cartCheckoutTemporaryAuthorization": "cartCheckoutTemporaryAuthorization-module-scss-module__mdutSq__cartCheckoutTemporaryAuthorization",
});
